import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { SharedModule } from '../../../core/shared.module';
import { FiltroService } from '../../../service/filtro.service';
import { Attori } from '../../enum/attori.enum';
import { AutocompleteComponent } from '../autocomplete/autocomplete.component';
import { tipologicaInterface } from '../../../interfaces/tipologica.interface';
import { DateConversionService } from '../../utilities/dateconversion.service';
@Component({
  selector: 'app-filtro-modifiche',
  standalone: true,
  templateUrl: './filtro-modifiche.component.html',
  imports: [SharedModule, AutocompleteComponent],
})
export class FiltroModificheComponent {
  form: FormGroup;
  @Input() attore: number = 0;
  @Output() searchEvent = new EventEmitter();
  @Input() commesse: tipologicaInterface[] = [];
  @Input() uoPrimoLivello: tipologicaInterface[] = [];
  attori = Attori;

  constructor(
    private fb: FormBuilder,
    private filtroService: FiltroService,
    private dateConversionService: DateConversionService,
  ) {
    this.form = this.fb.group({
      nomeRisorsa: [''],
      risorsa: [''],
      commessaSorgente: [''],
      interventoSorgente: [''],
      commessaDestinazione: [''],
      interventoDestinazione: [''],
      descrizioneUnitaOrganizzativaPrimoLivello: [''],
      nomeApprovatore: [''],
      dataApprovazione: [''],
    });
  }

  get commessaSorgente() {
    return this.form.get('commessaSorgente') as FormControl;
  }
  get interventoSorgente() {
    return this.form.get('interventoSorgente') as FormControl;
  }
  get commessaDestinazione() {
    return this.form.get('commessaDestinazione') as FormControl;
  }
  get interventoDestinazione() {
    return this.form.get('interventoDestinazione') as FormControl;
  }

  ngOnInit(): void {
    this.filtroService.ultimoFiltroRiepilogoModifiche(this.attore).subscribe((filtro) => {
      this.form.patchValue({ ...filtro });
      this.commessaSorgente.patchValue(
        this.commesse.find((c) => c.id === filtro.codiceCommessaSorgente) ?? null,
        { emitEvent: false }
      );
      this.commessaDestinazione.patchValue(
        this.commesse.find((c) => c.id === filtro.codiceCommessaDestinazione) ?? null,
        { emitEvent: false }
      );
      if (filtro.dataApprovazione)
        this.form
          .get('dataApprovazione')
          ?.patchValue(
            this.dateConversionService.convertDateToISO(
              filtro.dataApprovazione
            ),
            { emitEvent: false }
          );
    });
  }

  search(reset?: boolean): void {
    if (reset) {
      this.form.reset();
    }

    const retValue = { ...this.form.value };

    if (retValue.dataApprovazione) {
      retValue.dataApprovazione =
        this.dateConversionService.convertDateToDDMMYYYY(
          retValue.dataApprovazione
        );
    }

    this.filtroService.setUltimoFiltroRiepilogoModifiche(retValue, this.attore);
    this.searchEvent.emit(retValue);
  }
}
